import React, { useEffect } from "react";
import { graphql } from "gatsby";
import PropTypes from "prop-types";

import "./topic.scss";

import PageList from "../../components/PageList/pageList";
import BreadCrumb from "../../components/BreadCrumb/breadCrumb";
import TopicDesktop from "../../components/TopicDesktop/topicDesktop";
import Header from "../../components/Header/header";
import CTALabel from "../../components/CTALabel/ctaLabel";
import { isTokenPresent } from "../../utils/cookieHelper";

import {
  ingestData,
  isMobile,
} from "../../bridges/BridgeServices";
import SearchInput from "../../components/SearchInput/searchInput";
import MobileHeader from "../../components/MobileHeader/mobileHeader";
import { isShowWebHeader } from "../../utils/helperFunctions";
import { EVENTS } from "../../utils/constants";

const Topic = ({
  data: { wpPage: { uri = "", categoryAndTag = "" } = {} },
  pageContext: {
    allPagesData = {},
    searchDataArrayObject = [],
  },
}) => {
  const {
    "child-pages": childPages = [],
    title = "",
    seoTitle,
    seoMetaDesc,
    ctaDetails,
  } = allPagesData[uri] || {};

  useEffect(() => {
    ingestData({
      name: EVENTS.FAQ_CATEGORY_LOADED,
      data: {
        faqTitle: title,
      },
    });
  }, []);

  return (
    <div className="topic">
      <Header
        title={seoTitle}
        description={seoMetaDesc}
        searchData={searchDataArrayObject}
        pageURI={uri}
        faqTitle={title}
      />

      <div className="sub-topic-list">
        {/* adding an extra div for server side rendering */}
        <div className="mobile-search-input-wrapper">
          {isMobile() ? (
            isShowWebHeader() ? (
              <MobileHeader
                variant="compressed"
                faqTitle={title}
              />
            ) : (
              <SearchInput data={searchDataArrayObject} />
            )
          ) : null}
        </div>
        <BreadCrumb uri={uri} allPagesData={allPagesData} />

        <PageList
          allPagesData={allPagesData}
          pages={childPages}
          heading={title}
          showIcon={true}
          categoryAndTag={categoryAndTag?.categoryAndTag}
          isTopicPage
        />
      </div>
      <TopicDesktop
        uri={childPages[0]}
        allPagesData={allPagesData}
      />
      {/* Topics in web will open 1st subtopic by default so any cta added by cms in topic will not be shown in web
       * Add the cta in the required sub-topic for the same.
       * Added here for mobile only.
       */}
      {ctaDetails && isMobile() && isTokenPresent() && (
        <CTALabel faqTitle={title} {...ctaDetails} />
      )}
    </div>
  );
};

Topic.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default Topic;

export const query = graphql`
  query TopicPageById($id: String!) {
    wpPage(id: { eq: $id }) {
      uri
      categoryAndTag {
        categoryAndTag
      }
    }
  }
`;
